import React, { useCallback } from 'react'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'

const SelectorButton = ({ onClick, title, type, icon }) => {
  const handleOnClick = useCallback(() => onClick(type), [onClick, type])

  return (
    <Button customIcon={icon} type="tertiary" onClick={handleOnClick}>
      {title}
    </Button>
  )
}

export default SelectorButton
